module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "video-card box"
  }, [_c('article', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('figure', {
    staticClass: "image is-128x128"
  }, [(_vm.video.processed) ? _c('router-link', {
    staticClass: "thumbnail mr-4",
    attrs: {
      "to": '/videos/' + _vm.video.id
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.video.thumbnail,
      "alt": "video thumbnail"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.video.processed) ? _c('section', [_c('h2', [_vm._v("Processing...")]), _vm._v(" "), _c('Loader')], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [(_vm.shared) ? _c('strong', [_vm._v(_vm._s(_vm._f("video.user.email")(_vm.video.user.name)))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "vid-link",
    attrs: {
      "to": '/videos/' + _vm.video.id
    }
  }, [_vm._v(_vm._s(_vm.video.title))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm._f("prettyTimeStamp")(_vm.video.created_on)))])], 1)]), _vm._v(" "), _c('nav', {
    staticClass: "level is-mobile"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('a', {
    staticClass: "level-item"
  }, [(_vm.video.is_shared) ? _c('SharedWithUsersIcon') : _vm._e()], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "level-item"
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-retweet"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "level-item"
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-heart"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-c292b24e"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoCard.vue
// module id = 1083
// module chunks = 0